import { refreshIcons } from '../../base/utils.js';
export function initTooltips() {
    const triggers = document.querySelectorAll('[data-toggle="tooltip"]');
    triggers.forEach(trigger => {
        const wrapper = document.createElement('div');
        wrapper.className = 'tooltip-wrapper';
        trigger.parentNode.insertBefore(wrapper, trigger);
        wrapper.appendChild(trigger);

        const text = trigger.getAttribute('title');
        if (text) {
            trigger.removeAttribute('title');
            const placement = trigger.getAttribute('data-placement') || 'top';
            const tooltip = document.createElement('div');
            tooltip.className = `tooltip tooltip-${placement}`;
            tooltip.textContent = text;
            wrapper.appendChild(tooltip);
        }
    });
}
